export default { init }

    function init() {
        var cookieName = "SYMBrowserOutdated";
        var getCookieHelper = function (cname) {
            var name = cname + "=";
            var ca = document.cookie.split(';');
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == ' ') c = c.substring(1);
                if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
            }
            return "";
        };

        var setCookieHelper = function () {
            var expirationDateTicks = new Date();
            expirationDateTicks.setTime(expirationDateTicks.getTime() + (30 * 24 * 60 * 60 * 1000));
            var expires = "expires=" + expirationDateTicks.toUTCString();
            document.cookie = cookieName + "=Clicked;" + expires + "; path=/; domain=" + window.location.hostname;
        };

        var hasForceCookieHash = (!!window.location.hash && window.location.hash == "#browserwarning");
        var isOldBrowser = isOldBrowserVersion();

        if (hasForceCookieHash || isOldBrowser) {

            var $browserSupportBanner = $(".BrowserSupport");
            var $header = $("header");
            var oldHeaderHeight = parseInt($header.css("padding-top"));

            if (getCookieHelper(cookieName) == "" || hasForceCookieHash) {
                $('body').addClass('is-old-browser');
                var bannerHeight = $browserSupportBanner.height();
                var bannerClickUrl = $browserSupportBanner.attr("data-click-target");

                $browserSupportBanner.slideDown("fast");

                $header.animate({
                    "padding-top": oldHeaderHeight + bannerHeight + "px"
                }, "fast");

                $browserSupportBanner.on('click', function (e) {
                    if (!e.target.tagName.match(/a/i)) {
                        e.preventDefault();
                        $('body').removeClass('is-old-browser');
                        setCookieHelper();

                        if (!!bannerClickUrl && bannerClickUrl.length > 0) {
                            window.location = bannerClickUrl;
                        } else {
                            $browserSupportBanner.slideUp("fast");

                            $header.animate({
                                "padding-top": oldHeaderHeight + "px"
                            }, "fast");
                        }
                    }
                });
            }
        } else {
            document.body.classList.remove('is-old-browser');
        }
    }

    function isOldBrowserVersion() {
        if (navigator.userAgent.indexOf('MSIE') !== -1) {
            // This is internet explorer <=10
            return true;
        }
        return false;
    }

